import { reduxKey } from './constants';
import { CoreBadgeStateSlice } from '../types';
import { getCurrentModal } from '../../Modals/redux/selectors';
import { ModalType } from '../../Modals/redux/types';

function getStateSlice(state): CoreBadgeStateSlice {
  return state[reduxKey] || {};
}

export function isAwardModalOpen(state) {
  return getCurrentModal(state)?.type === ModalType.AWARD_BADGE;
}

export function getAwardModalBadges(state, userId: number) {
  const awardableBadges = getStateSlice(state).awardableBadges?.[userId];
  if (!awardableBadges) {
    return [];
  }
  return awardableBadges.results;
}

export function getGemRestrictions(state) {
  return getStateSlice(state).gemRestrictions;
}

export function getIsAwarding(state) {
  return getStateSlice(state).isAwarding;
}

export function getErrorMsg(state) {
  return getStateSlice(state).errorMsg;
}
